import { Decimal } from "@kase/my-marathon-communication";
import { isSameDay, startOfMonth } from "date-fns";
import { TIME_COLORS } from "~/core/color-manager";
import { getDayContract } from "~/core/slices/api/employee/utils";
import { store } from "~/core/store";
import { dateFromApi } from "~/utils";
import { ReportProgressRangeType } from "./interfaces";

const getReportProgress = (date: Date, range: ReportProgressRangeType) => {
    const { time, employee } = store.api;
    const labels: string[] = ["Contracted", "Reported"];
    const values: number[] = [0, 0];
    const colors: string[] = [TIME_COLORS.contracted, TIME_COLORS.reported];

    const start = range === "day" ? date : startOfMonth(date);
    const contracts = employee.me.peek()?.contracts.peek() ?? [];
    const reports = time.report.reports.peek();
    const current = new Date(start);

    let totalContracted = 0;
    let totalReported = 0;

    while (
        current.getMonth() === date.getMonth() &&
        current.getDate() <= date.getDate()
    ) {
        const contract = getDayContract(contracts, current);
        const contracted = contract?.contracted_day
            ? new Decimal(contract.contracted_day).toNumber()
            : 0;
        const reported = reports
            .filter((i) => isSameDay(current, dateFromApi(i.date)))
            .reduce(
                (acc, item) =>
                    acc +
                    (item.line_type?.$case === "fee"
                        ? (item.line_type.fee.hours?.toNumber() ?? 0)
                        : 0),
                0,
            );

        totalContracted += contracted;
        totalReported += reported;
        current.setDate(current.getDate() + 1);
    }

    values[0] = totalContracted;
    values[1] = totalReported;

    if (totalReported > totalContracted) {
        values[1] = totalContracted;

        // add "overflow" slice
        values[2] = totalReported % totalContracted || totalContracted;
        labels[2] = "Overflow";
        colors[2] = TIME_COLORS.overReported;
    }

    return {
        labels,
        values,
        colors,
        total: totalContracted,
        reported: totalReported,
    };
};

export default getReportProgress;
